import CityPageTemplate from "../city-template/CityPageTemplate";
import { columbiaMoConfig } from "./data";

export default function ColumbiaMoPage() {
  return <CityPageTemplate config={columbiaMoConfig} />;
}